import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/Tagbar/Tagbar.css';

export const prototypeName = 'vRPlwbreQXcp7oza0X1yfzvGGqyADKTnOVAVn61qiMnPAjZjNdckrvrNDljrT2ONgW8wDd';
export {styles};